import React from 'react';
import PropTypes from 'prop-types';
import './BrandOnboardingControls.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSearch } from '@fortawesome/pro-regular-svg-icons';

const BrandOnboardingControls = props => {
  const { curSearchValue, setCurSearchValue } = props;

  return (
    <div className='brand-onboarding-controls-outer'>
      <div className='brand-onboarding-controls-inner'>
        <div className='brand-onboarding-controls-input-container'>
          <FontAwesomeIcon icon={faSearch} className='brand-onboarding-controls-search-icon' />
          <input
            type='text'
            className='brand-onboarding-controls-input'
            placeholder='Search registration codes...'
            value={curSearchValue}
            onChange={e => setCurSearchValue(e.target.value)}
          />
          {!!curSearchValue && (
            <FontAwesomeIcon icon={faTimes} className='brand-onboarding-controls-input-icon' onClick={() => props.resetSearch()} />
          )}
        </div>
      </div>
    </div>
  );
};

BrandOnboardingControls.propTypes = {
  curSearchValue: PropTypes.string.isRequired,
  setCurSearchValue: PropTypes.func.isRequired,
  resetSearch: PropTypes.func.isRequired
};

export default BrandOnboardingControls;
